import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';

import { GalaxyImageEditorComponent } from './components/image-editor/image-editor.component';
export { AspectRatioPreset, GalaxyImageEditorComponent } from './components/image-editor/image-editor.component';
export { GalaxyImageListComponent } from './components/image-list/image-list.component';
export { GalaxyImageUploadTileComponent } from './components/image-upload-tile/image-upload-tile.component';
export { GalaxyImageUploaderComponent } from './components/image-uploader/image-uploader.component';
export { GalaxyUploaderListComponent } from './components/uploader-list/uploader-list.component';
export { GalaxyUploaderComponent } from './components/uploader/uploader.component';

import { GalaxyImageListComponent } from './components/image-list/image-list.component';

import { GalaxyImageUploadTileComponent } from './components/image-upload-tile/image-upload-tile.component';

import { GalaxyImageUploaderComponent } from './components/image-uploader/image-uploader.component';

import { GalaxyUploaderConstraintsTextComponent } from './components/uploader-constraints-text/uploader-constraints-text.component';
import { GalaxyUploaderFileStatusComponent } from './components/uploader-file-status/uploader-file-status.component';
import { GalaxyUploaderFileComponent } from './components/uploader-file/uploader-file.component';

import { GalaxyUploaderListComponent } from './components/uploader-list/uploader-list.component';

import { GalaxyFileDragDropComponent } from './components/file-drag-drop/file-drag-drop.component';
import { GalaxyUploaderComponent } from './components/uploader/uploader.component';

export { GalaxyImageUploaderService } from './image-uploader.service';
export { GalaxyUploaderService } from './uploader.service';

export { GalaxyFileDragDropComponent as FileDragDropComponent } from './components/file-drag-drop/file-drag-drop.component';

export const MODULE_IMPORTS = [
  CommonModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  MatIconModule,
  TranslateModule,
  MatInputModule,
  MatRadioModule,
  MatSelectModule,
  GalaxyFormFieldModule,
  GalaxyLoadingSpinnerModule,
  ReactiveFormsModule,
];

export const MODULE_DECLARATIONS = [
  GalaxyUploaderComponent,
  GalaxyUploaderFileComponent,
  GalaxyUploaderFileStatusComponent,
  GalaxyUploaderListComponent,
  GalaxyUploaderConstraintsTextComponent,
  GalaxyImageUploaderComponent,
  GalaxyImageEditorComponent,
  GalaxyImageListComponent,
  GalaxyImageUploadTileComponent,
  GalaxyFileDragDropComponent,
];

export const MODULE_EXPORTS = [
  GalaxyUploaderComponent,
  GalaxyUploaderListComponent,
  GalaxyImageUploaderComponent,
  GalaxyImageEditorComponent,
  GalaxyImageListComponent,
  GalaxyImageUploadTileComponent,
  GalaxyFileDragDropComponent,
];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: MODULE_EXPORTS,
})
export class GalaxyUploaderModule {}
